<template>
    <div class="aprh__authentication__forgot-password">
        <template v-if="!helpers.isSuccessForgot">
            <div class="aprh__authentication__form__description">
                {{ $t('authentication.AnEmailWillBeSentToRedifineYourPassword') }}
            </div>
            <component
                :is="input"
                class="aprh__authentication__form__field"
                :settings="{
                    label: { class: 'field__label__login capitalize', text: $t('global.email') },
                    input: {
                        component: 'InputBasic',
                        id: 'email',
                        name: 'email',
                        type: 'text',
                        class: 'aprh__authentication__form__field__input',
                        value: '',
                        placeholder: $t('global.email'),
                        browserAutocomplete: 'email',
                        isRequired: true,
                        fileValidation: 'basicEmail',
                        errors: [{
                            type: 'email', warning: $t('error.email')
                        }],
                        isMissing: errors.missing.email,
                        noListener: true
                    },
                    allowFilling: true
                }"
            />
        </template>
        <template v-else>
            <div class="aprh__authentication__form__description">
                {{ $t('authentication.anEmailWasSentTo') }}
                <span class="aprh__authentication__form__description__email display--block">{{ helpers.formData.email }}</span>
            </div>
            <div class="aprh__authentication__form__description">
                {{ $t('authentication.didntReceiveTheEmail') }}
                <base-button
                    type="submit"
                    class="aprh__authentication__form__resend-link color--blue display--block"
                    v-html="$t(`authentication.resendLink`)"
                />
            </div>
        </template>
    </div>
</template>

<script>
// store
// eslint-disable-next-line
import { mapState } from '@/hooks/use-store';

export default {
    components: {
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    props: {
        input: Function,
        helpers: Object
    },
    setup () {
        const errors = mapState({ module: 'storePayload', key: 'errors' });

        return { errors };
    }
};
</script>